module.exports = __webpack_public_path__ + "static/media/unpin_img.f0a6c276.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unpin_img.svg
// module id = 662
// module chunks = 7